"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 5rem;\n  max-height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var LogoImage = _styledComponents["default"].img(_templateObject());

var Logo = function Logo() {
  return /*#__PURE__*/_react["default"].createElement(LogoImage, {
    src: require('./ace-logo.png')
  });
};

var _default = Logo;
exports["default"] = _default;
module.exports = exports["default"];